import styled from 'styled-components';
import { Typography } from '../../global/theme';

export const Container = styled.div`
  position: relative;
  width: 100%;
`;

export const InputWrapper = styled.div`
  position: relative;
  width: 100%;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const Input = styled.input`
  width: 100%;
  min-width: 206px;
  padding: 8px 12px;
  border: 1px solid var(--border-primary);
  border-radius: 8px;
  background: var(--background-primary);
  color: var(--text-primary);
  ${Typography.body_lg_medium}
  cursor: pointer;
  &::placeholder {
    color: var(--text-placeholder);
  }
  &:focus {
    outline: none;
    border-color: var(--brand-primary);
  }
`;

export const IconDiv = styled.div`
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  opacity: 1;
  transition: opacity 0.3s;
  svg {
    fill: var(--text-primary);
  }
  ${InputWrapper}:has(input:not(:placeholder-shown)):hover & {
    opacity: 0;
  }
`;

export const ClearIcon = styled.div`
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  cursor: pointer;
  opacity: 0;
  transition: opacity 0.3s;

  ${InputWrapper}:has(input:not(:placeholder-shown)):hover & {
    opacity: 1;
  }
`;

export const ErrorText = styled.div`
  color: var(--text-error);
  ${Typography.body_xs}
  margin-top: 4px;
`;

export const CalendarWrapper = styled.div`
  position: absolute;
  z-index: 9999;
  background-color: var(--background-primary);
  border-radius: 8px;
  border: 0.5px solid var(--border-primary);
  .custom-calendar .react-calendar__navigation {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 8px;
    border-bottom: 0.5px solid var(--border-primary);
  }

  .custom-calendar .react-calendar__navigation button {
    background: none;
    border: none;
    padding: 0;
    margin: 0;
    cursor: pointer;
    width: 22px;
    height: 40px;
    ${Typography.body_lg_medium}
    color: var(--text-primary);
  }

  .custom-calendar .react-calendar__navigation__label {
    font-weight: 500;
    color: var(--text-primary);
  }

  .react-calendar__viewContainer {
    padding: 8px 18px;
  }

  .custom-calendar .react-calendar__month-view__weekdays {
    font-weight: 500;
    font-size: 14px;
    color: var(--text-secondary);
  }

  .custom-calendar .react-calendar__month-view__weekdays__weekday {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 36px;
    width: 36px;
  }
  .react-calendar__month-view__days {
    display: grid !important;
    grid-template-columns: repeat(7, 1fr);
    gap: 2px;
  }
  .custom-calendar .react-calendar__month-view__days__day {
    height: 24px;
    width: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--text-primary);
  }

  .custom-calendar .react-calendar__tile {
    background: none;
    border-radius: 8px;
    transition: back ground-color 0.3s, color 0.3s;
    border: none;
    margin: 5px;
  }

  .custom-calendar .react-calendar__tile:enabled:hover,
  .custom-calendar .react-calendar__tile:enabled:focus {
    background-color: var(--neutral-secondary);
  }

  .custom-calendar .react-calendar__tile--now {
    background: var(--neutral-secondary);
    color: var(--text-primary);
  }

  .custom-calendar .react-calendar__tile--now:enabled:hover,
  .custom-calendar .react-calendar__tile--now:enabled:focus {
    background: var(--neutral-secondary);
  }

  .custom-calendar .react-calendar__tile--active {
    background: var(--brand-primary);
    color: var(--text-white);
  }

  .custom-calendar .react-calendar__tile--active:enabled:hover,
  .custom-calendar .react-calendar__tile--active:enabled:focus {
    background: var(--brand-primary);
    color: var(--text-white);
  }

  .custom-calendar .react-calendar__tile--hasActive {
    background: var(--brand-primary);
    color: var(--text-white);
  }

  .custom-calendar .react-calendar__tile--hasActive:enabled:hover,
  .custom-calendar .react-calendar__tile--hasActive:enabled:focus {
    background: var(--text-primary);
    color: var(--text-white);
  }

  .custom-calendar .react-calendar__tile--other-month {
    color: var(--text-secondary);
  }
`;

export const Footer = styled.div`
  border-top: 0.5px solid var(--border-primary);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 12px 10px 7px;
  ${Typography.body_md} p {
    padding: 9px 0px;
    color: var(--text-primary);

    margin: 0;
  }
`;
